import { useState } from "react";
import { useSelector } from "react-redux";
import { isEmpty } from "lodash";

import GetMetaButton from "./GetMetaButton/GetMetaButton";
import MenuItem from "./MenuItem/MenuItem";
import CategoryImage from "./CategoryImage/CategoryImage";
import { menuImage } from "../utils";

const Menu = () => {
  const categories = useSelector((state) => state.meta?.categories);
  const subCategories = useSelector((state) => state.meta?.subCategories);
  const menus = useSelector((state) => state.meta?.menus);
  const setting = useSelector((state) => state.meta?.setting);

  const [filterKey, setFilterKey] = useState("all");

  const handleFilterKeyChange = (key) => () => {
    setFilterKey(key);
    document
      .getElementById("menu")
      .scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const rendredItems = () => {
    let item = [];
    const sub =
      filterKey === "all"
        ? subCategories
        : subCategories.filter((s) => s?.category === filterKey);
    for (let i = 0; i < sub?.length; i++) {
      const subCategory = sub[i];
      const subMenus = menus.filter((m) => m?.subCategory === subCategory?._id);
      item.push({
        title: subCategory?.title,
        image: subCategory?.image,
        items: subMenus,
      });
    }
    return item?.map((_item, index) => (
      <div key={index}>
        {_item?.title && (
          <div className="text-center">
            <h3 className="d-inline-block fw-bold">
              {_item?.image && (
                <>
                  <CategoryImage image={_item.image} title={_item.title} />
                  <hr />
                </>
              )}
              <span>{_item?.title}</span>
            </h3>
          </div>
        )}
        <div className="row justify-content-center all-menu-items">
          {_item?.items?.map((_item2, index) => (
            <MenuItem key={index} data={_item2} />
          ))}
        </div>
      </div>
    ));
  };

  return (
    <section className="section kf-menu kf-menu-tabs pt-0">
      <div className="container">
        <div className="kf-filter kf-filter-menu" id="menu">
          {isEmpty(categories) ? (
            <GetMetaButton />
          ) : (
            <section className="section py-2">
              <div
                className="row align-items-center py-3"
                style={{ overflowX: "auto", flexWrap: "nowrap" }}
              >
                <div className="col-auto p-xl-0">
                  <a
                    className={`c-pointer d-block ${
                      filterKey === "all" ? "active" : ""
                    }`}
                    onClick={handleFilterKeyChange("all")}
                    data-href="all"
                  >
                    <CategoryImage title="همه" />
                    <hr className="border-white" />
                    <span>همه</span>
                  </a>
                </div>
                {categories?.map((_item) => (
                  <div className="col-auto p-xl-0" key={_item._id}>
                    <a
                      className={`c-pointer d-block ${
                        _item._id === filterKey ? "active" : ""
                      }`}
                      onClick={handleFilterKeyChange(_item._id)}
                      data-href={_item._id}
                    >
                      <CategoryImage image={_item.image} title={_item.title} />
                      <hr className="border-white" />
                      <span>{_item.title}</span>
                    </a>
                  </div>
                ))}
              </div>
            </section>
          )}
        </div>
        <div
          className="kf-menu-items"
          style={{ backgroundImage: "url(/assets/images/menu_logo.png)" }}
        >
          {rendredItems()}
        </div>
      </div>
    </section>
  );
};
export default Menu;
